import React, { useState, useEffect, useMemo } from "react";
import { useSearchParams } from "react-router-dom";

import Modal from "react-modal";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import MyInvitation from "./Invitation";
import RecievedInvitation from "./RecieveInvitation";
import CreateEventModal from "./CreateEventModal";
import DeleteEventModal from "./DeleteEventModal";
import { getApi, putApi, deleteApi } from "../../../Services/apiService";
import { getFamilyTreeIdFromStorage } from "../../../Utils/headOfLineRole";

function Event() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabFromUrl = searchParams.get("tab");

  const [activeTab, setActiveTab] = useState(() => {
    if (tabFromUrl === "received") return "received";
    if (tabFromUrl === "archived") return "archived";
    if (tabFromUrl === "draft") return "draft";
    return "myInvitations";
  });
  const [showPopup, setShowPopup] = useState(false);
  const [eventDetail, setEventDetail] = useState({});
  const [editMode, setEditMode] = useState("");
  const [search, setSearch] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);

  const [recievedInvitationCount, setRecievedInvitationCount] = useState(0);
  const [myInvitations, setMyInvitations] = useState([]);
  const [receivedInvitations, setReceivedInvitations] = useState([]);
  const [archivedInvitations, setArchivedInvitations] = useState([]);
  const [draftInvitations, setDraftInvitations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [deleteMode, setDeleteMode] = useState("delete");
  const [archivedStartDate, setArchivedStartDate] = useState("");
  const [archivedEndDate, setArchivedEndDate] = useState("");
  const [archivedYear, setArchivedYear] = useState("");
  const [selectedArchivedIds, setSelectedArchivedIds] = useState([]);
  const [showCancelledArchivedOnly, setShowCancelledArchivedOnly] = useState(false);
  const [showBulkDeleteModal, setShowBulkDeleteModal] = useState(false);
  const [bulkDeleting, setBulkDeleting] = useState(false);
  const [archivedEventTypes, setArchivedEventTypes] = useState([]);
  const [archivedHostFilter, setArchivedHostFilter] = useState("");
  const [archivedTypeFilter, setArchivedTypeFilter] = useState("");
  const [archivedLineColorFilter, setArchivedLineColorFilter] = useState("");
  const [showArchivedHostDropdown, setShowArchivedHostDropdown] = useState(false);
  const [showArchivedTypeDropdown, setShowArchivedTypeDropdown] = useState(false);
  const [showArchivedLineColorDropdown, setShowArchivedLineColorDropdown] = useState(false);
  const { RangePicker } = DatePicker;
  
  // Counts from API response
  const [sentEventsCount, setSentEventsCount] = useState(0);
  const [archivedEventsCount, setArchivedEventsCount] = useState(0);
  const [draftEventsCount, setDraftEventsCount] = useState(0);
  const [receivedEventsCounts, setReceivedEventsCounts] = useState({
    all: 0,
    accepted: 0,
    declined: 0,
    pending: 0,
  });

  //Get user from local storage and update the family_tree_id
  const [familyTreeId, setFamilyTreeId] = useState("");

  const archivedRangeDisplay =
    archivedStartDate && archivedEndDate
      ? `${dayjs(archivedStartDate).format("DD/MM/YYYY")} - ${dayjs(archivedEndDate).format("DD/MM/YYYY")}`
      : "";

  //Fetch the user from the local storage
  useEffect(() => {
    setFamilyTreeId(getFamilyTreeIdFromStorage() || "");
  }, []);

  // Sync activeTab from URL (e.g. after login redirect to /events?tab=received)
  useEffect(() => {
    const tab = searchParams.get("tab");
    if (tab === "received") setActiveTab("received");
    else if (tab === "archived") setActiveTab("archived");
    else if (tab === "draft") setActiveTab("draft");
    else if (tab === "myInvitations" || !tab) setActiveTab("myInvitations");
  }, [searchParams]);

  const setActiveTabAndUrl = (tab) => {
    setActiveTab(tab);
    if (tab === "myInvitations") setSearchParams({});
    else setSearchParams({ tab });
  };

  // Fetch events based on active tab
  const fetchEvents = async (filter = "", searchTerm = "") => {
    if (!familyTreeId) return;
    setLoading(true);
    try {
      if (activeTab === "myInvitations") {
        const searchQuery = searchTerm
          ? `&search=${encodeURIComponent(searchTerm)}`
          : "";
        const response = await getApi(
          `/get_events?family_tree_id=${familyTreeId}&type=0${searchQuery}`
        );
        setMyInvitations(response?.data || []);
        // Update counts from API response
        if (response?.counts) {
          setSentEventsCount(response.counts.sent_events || 0);
          setArchivedEventsCount(response.counts.archive_events || 0);
          setDraftEventsCount(response.counts.draft_events ?? 0);
          if (response.counts.received_events) {
            setReceivedEventsCounts({
              all: response.counts.received_events.all || 0,
              accepted: response.counts.received_events.accepted || 0,
              declined: response.counts.received_events.declined || 0,
              pending: response.counts.received_events.pending || 0,
            });
            setRecievedInvitationCount(response.counts.received_events.all || 0);
          }
        }
      } else if (activeTab === "draft") {
        const searchQuery = searchTerm
          ? `&search=${encodeURIComponent(searchTerm)}`
          : "";
        const response = await getApi(
          `/get_events?family_tree_id=${familyTreeId}&type=3${searchQuery}`
        );
        const draftList = response?.data || [];
        setDraftInvitations(draftList);
        setDraftEventsCount(response?.counts?.draft_events ?? draftList.length);
        if (response?.counts) {
          setSentEventsCount(response.counts.sent_events || 0);
          setArchivedEventsCount(response.counts.archive_events || 0);
          setDraftEventsCount(response.counts.draft_events ?? 0);
          if (response.counts.received_events) {
            setReceivedEventsCounts({
              all: response.counts.received_events.all || 0,
              accepted: response.counts.received_events.accepted || 0,
              declined: response.counts.received_events.declined || 0,
              pending: response.counts.received_events.pending || 0,
            });
            setRecievedInvitationCount(response.counts.received_events.all || 0);
          }
        }
      } else if (activeTab === "received") {
        const searchQuery = searchTerm
          ? `&search=${encodeURIComponent(searchTerm)}`
          : "";
        const response = await getApi(
          `/get_events?family_tree_id=${familyTreeId}&type=1&filter=${filter}${searchQuery}`
        );
        setReceivedInvitations(response?.data || []);
        // Update counts from API response
        if (response?.counts) {
          setSentEventsCount(response.counts.sent_events || 0);
          setArchivedEventsCount(response.counts.archive_events || 0);
          setDraftEventsCount(response.counts.draft_events ?? 0);
          if (response.counts.received_events) {
            setReceivedEventsCounts({
              all: response.counts.received_events.all || 0,
              accepted: response.counts.received_events.accepted || 0,
              declined: response.counts.received_events.declined || 0,
              pending: response.counts.received_events.pending || 0,
            });
            setRecievedInvitationCount(response.counts.received_events.all || 0);
          }
        }
      } else if (activeTab === "archived") {
        const searchQuery = searchTerm
          ? `&search=${encodeURIComponent(searchTerm)}`
          : "";

        const filterParams = [];

        // Format helper: YYYY-MM-DD -> DD/MM/YYYY
        const formatYMDToDMY = (value) => {
          if (!value) return "";
          const [year, month, day] = String(value).split("-");
          if (!year || !month || !day) return value;
          return `${day.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`;
        };

        if (archivedStartDate && archivedEndDate) {
          const from = formatYMDToDMY(archivedStartDate);
          const to = formatYMDToDMY(archivedEndDate);
          filterParams.push(`from=${encodeURIComponent(from)}`);
          filterParams.push(`to=${encodeURIComponent(to)}`);
        }
        if (archivedYear) {
          filterParams.push(`year=${encodeURIComponent(archivedYear)}`);
        }

        const filterQuery =
          filterParams.length > 0 ? `&${filterParams.join("&")}` : "";

        const response = await getApi(
          `/get_events?family_tree_id=${familyTreeId}&type=2${searchQuery}${filterQuery}`
        );
        setArchivedInvitations(response?.data || []);

        // Capture event types list from API (if provided) for type-of-event dropdown
        const typesFromResponse =
          response?.event_types ||
          response?.data?.event_types ||
          response?.data?.eventTypes ||
          [];
        if (Array.isArray(typesFromResponse)) {
          setArchivedEventTypes(typesFromResponse);
        } else {
          setArchivedEventTypes([]);
        }
        // Update counts from API response
        if (response?.counts) {
          setSentEventsCount(response.counts.sent_events || 0);
          setArchivedEventsCount(response.counts.archive_events || 0);
          setDraftEventsCount(response.counts.draft_events ?? 0);
          if (response.counts.received_events) {
            setReceivedEventsCounts({
              all: response.counts.received_events.all || 0,
              accepted: response.counts.received_events.accepted || 0,
              declined: response.counts.received_events.declined || 0,
              pending: response.counts.received_events.pending || 0,
            });
            setRecievedInvitationCount(response.counts.received_events.all || 0);
          }
        }
      }
    } catch (error) {
      console.error("Error fetching events:", error);
      // Set empty arrays on error
      if (activeTab === "myInvitations") {
        setMyInvitations([]);
      } else if (activeTab === "received") {
        setReceivedInvitations([]);
      } else if (activeTab === "draft") {
        setDraftInvitations([]);
      } else if (activeTab === "archived") {
        setArchivedInvitations([]);
      }
    } finally {
      setLoading(false);
    }
  };

  // Refresh events (when on "received" tab, pass filter so API gets all/accepted/declined/pending)
  const refreshEvents = (data) => {
    let filter = data ?? "";
    if (activeTab === "received") {
      filter = data !== undefined && data !== null ? (data === "all" ? "" : data) : "";
    }
    return fetchEvents(filter, search);
  };

  useEffect(() => {
    if (!familyTreeId) return;
    refreshEvents();
  }, [activeTab, search, familyTreeId]);

  const handleApplyArchivedDateRange = () => {
    if (!archivedStartDate || !archivedEndDate) {
      return refreshEvents();
    }
    return refreshEvents();
  };

  const handleClearArchivedDateRange = () => {
    setArchivedStartDate("");
    setArchivedEndDate("");
    refreshEvents();
  };

  const handleApplyArchivedYear = () => {
    if (!archivedYear) {
      return refreshEvents();
    }
    return refreshEvents();
  };

  const handleClearArchivedYear = () => {
    setArchivedYear("");
    refreshEvents();
  };

  const toggleSelectArchived = (eventId) => {
    setSelectedArchivedIds((prev) =>
      prev.includes(eventId)
        ? prev.filter((id) => id !== eventId)
        : [...prev, eventId]
    );
  };

  const toggleSelectAllArchived = () => {
    if (!archivedInvitations || archivedInvitations.length === 0) {
      setSelectedArchivedIds([]);
      return;
    }
    const allIds = archivedInvitations
      .map((evt) => evt.id)
      .filter((id) => id != null);
    const allSelected =
      allIds.length > 0 &&
      allIds.every((id) => selectedArchivedIds.includes(id));
    setSelectedArchivedIds(allSelected ? [] : allIds);
  };

  const performBulkDeleteArchived = async () => {
    if (!selectedArchivedIds.length) return;

    try {
      setBulkDeleting(true);
      await deleteApi("/delete-events", {
        data: {
          event_ids: selectedArchivedIds,
        },
      });
      setSelectedArchivedIds([]);
      refreshEvents();
      setShowBulkDeleteModal(false);
    } catch (err) {
      console.error("Error deleting archived events:", err);
    } finally {
      setBulkDeleting(false);
    }
  };

  const handleBulkDeleteArchived = () => {
    if (!selectedArchivedIds.length) return;
    setShowBulkDeleteModal(true);
  };

  const archivedHostOptions = useMemo(() => {
    const set = new Set();
    archivedInvitations.forEach((evt) => {
      const hostName =
        evt?.Host?.first_name ||
        (evt?.host_name ? evt.host_name.split(" ")[0] : "") ||
        "";
      if (hostName) set.add(hostName);
    });
    return Array.from(set).sort();
  }, [archivedInvitations]);

  const archivedTypeOptions = useMemo(() => {
    const set = new Set();

    if (archivedEventTypes && archivedEventTypes.length) {
      archivedEventTypes.forEach((t) => {
        const name =
          t?.name ||
          t?.event_type_name ||
          t?.type_name ||
          t?.label ||
          "";
        if (name) set.add(name);
      });
    } else {
      archivedInvitations.forEach((evt) => {
        const typeName =
          evt?.Event_Type?.name ||
          evt?.event_type_name ||
          evt?.type_name ||
          evt?.type_label ||
          "";
        if (typeName) set.add(typeName);
      });
    }

    return Array.from(set).sort();
  }, [archivedEventTypes, archivedInvitations]);

  const archivedLineColorOptions = useMemo(() => {
    const set = new Set();
    archivedInvitations.forEach((evt) => {
      const color =
        evt?.Host?.color_name ||
        evt?.host_color_name ||
        evt?.color_name ||
        "";
      if (color) set.add(color);
    });
    return Array.from(set).sort();
  }, [archivedInvitations]);

  const filteredArchivedInvitations = useMemo(() => {
    let list = archivedInvitations;
    if (showCancelledArchivedOnly) {
      list = list.filter(
        (evt) => evt?.status === 2 || evt?.status === "2"
      );
    }
    if (archivedHostFilter) {
      list = list.filter((evt) => {
        const hostName =
          evt?.Host?.first_name ||
          (evt?.host_name ? evt.host_name.split(" ")[0] : "") ||
          "";
        return hostName === archivedHostFilter;
      });
    }
    if (archivedTypeFilter) {
      list = list.filter((evt) => {
        const typeName =
          evt?.Event_Type?.name ||
          evt?.event_type_name ||
          evt?.type_name ||
          evt?.type_label ||
          "";
        return typeName === archivedTypeFilter;
      });
    }
    if (archivedLineColorFilter) {
      list = list.filter((evt) => {
        const color =
          evt?.Host?.color_name ||
          evt?.host_color_name ||
          evt?.color_name ||
          "";
        return color === archivedLineColorFilter;
      });
    }
    return list;
  }, [
    archivedInvitations,
    showCancelledArchivedOnly,
    archivedHostFilter,
    archivedTypeFilter,
    archivedLineColorFilter,
  ]);
  // Open Add/Edit modal
  const openAddEditModal = (mode, data) => {
    setEditMode(mode); // directly set string like "Add", "Edit", "View"
    setEventDetail(data || {});
    setShowPopup(true);
  };

  // Open Delete/Cancel modal
  const openDeleteModal = (eventData, mode = "delete") => {
    setSelectedEvent(eventData);
    setDeleteMode(mode);
    setShowDeleteModal(true);
  };

  // Handle modal close and refresh events after successful creation
  const handleModalClose = async (shouldRefresh = false) => {
    setShowPopup(false);
    if (shouldRefresh) {
      await refreshEvents();
    }
  };

  // Hide the top search + Add controls when the tab has no events at all,
  // since the empty state already shows a "Create Event" button.
  const isEmptyTabWithoutSearch =
    !loading &&
    !search &&
    ((activeTab === "myInvitations" && myInvitations.length === 0) ||
      (activeTab === "draft" && draftInvitations.length === 0));

  return (
    <div className="family-tree-container events">
      {/* ===== HEADER ===== */}
      <div className="family-tree-top">
        {/* ===== TABS ===== */}
        <div className="left-controls">
          <div className="view-tabs">
            <button
              className={`  ${activeTab === "myInvitations" ? "active" : ""}`}
              onClick={() => setActiveTabAndUrl("myInvitations")}
            >
              My Invitations ({sentEventsCount})
            </button>
            <button
              className={` ${activeTab === "draft" ? "active" : ""}`}
              onClick={() => setActiveTabAndUrl("draft")}
            >
              Draft Invitations ({draftEventsCount})
            </button>
            <button
              className={` ${activeTab === "received" ? "active" : ""}`}
              onClick={() => setActiveTabAndUrl("received")}
            >
              <span className="tab-label-full">Received</span>
              <span className="tab-label-short">Rec&rsquo;d</span>
              {` Invitations (${recievedInvitationCount})`}
            </button>
            <button
              className={` ${activeTab === "archived" ? "active" : ""}`}
              onClick={() => setActiveTabAndUrl("archived")}
            >
              Archived Invitations ({archivedEventsCount})
            </button>
          </div>
        </div>

        <div className="right-controls">
          {activeTab !== "archived" && !isEmptyTabWithoutSearch && (
            <>
              <div style={{ position: "relative", flex: "1 1 auto", minWidth: 0 }}>
                <input
                  type="text"
                  className="events-search-input"
                  placeholder="Search..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  style={search ? { paddingRight: "32px" } : undefined}
                />
                {search && (
                  <span
                    onClick={() => setSearch("")}
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "#555",
                      fontSize: "16px",
                      lineHeight: 1,
                      fontWeight: "bold",
                      userSelect: "none",
                    }}
                  >
                    ×
                  </span>
                )}
              </div>
              <div className="icon-tooltip-wrapper">
                <button
                  className="events-add-btn"
                  onClick={() => openAddEditModal("Add", "")}
                >
                  + Add
                </button>
                <div className="icon-tooltip">Create Event</div>
              </div>
            </>
          )}
        </div>
      </div>

      {activeTab === "archived" && (
        <div className="events-archived-filters">
          <div className="events-archived-filters-row events-archived-filters-row--dates">
          <div className="events-archived-filter-field">
            <label
              style={{
                fontSize: "12px",
                fontWeight: "600",
                display: "block",
                marginBottom: "2px",
              }}
            >
              Date Range
            </label>
            <div className="events-archived-filter-controls">
              <div className="archived-range-picker-wrapper">
                <RangePicker
                  value={
                    archivedStartDate && archivedEndDate
                      ? [dayjs(archivedStartDate), dayjs(archivedEndDate)]
                      : null
                  }
                  onChange={(values) => {
                    if (!values || values.length !== 2) {
                      setArchivedStartDate("");
                      setArchivedEndDate("");
                      return;
                    }
                    setArchivedStartDate(values[0].format("YYYY-MM-DD"));
                    setArchivedEndDate(values[1].format("YYYY-MM-DD"));
                  }}
                  format="DD/MM/YYYY"
                  separator="-"
                  allowClear={true}
                  placeholder={["Start date", "End date"]}
                  classNames={{ popup: { root: "archived-range-picker-dropdown" } }}
                  style={{
                    width: "180px",
                    border: "1px solid #D9D9D9",
                    borderRadius: "8px",
                    padding: "4px 8px",
                    height: "32px",
                    fontSize: "12px",
                  }}
                  className="archived-year-picker archived-range-picker"
                />
                <div className="archived-range-picker-display" aria-hidden="true">
                  {archivedRangeDisplay || "Start date - End date"}
                </div>
              </div>
              <button
                type="button"
                onClick={handleApplyArchivedDateRange}
                style={{
                  fontSize: "12px",
                  padding: "4px 8px",
                  borderRadius: "4px",
                  border: "1px solid #1890ff",
                  backgroundColor: "#1890ff",
                  color: "#fff",
                }}
              >
                Apply
              </button>
              <button
                type="button"
                onClick={handleClearArchivedDateRange}
                style={{
                  fontSize: "12px",
                  padding: "4px 8px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                  backgroundColor: "#fff",
                }}
              >
                Clear
              </button>
            </div>
          </div>
          <div className="events-archived-filter-field">
            <label
              style={{
                fontSize: "12px",
                fontWeight: "600",
                display: "block",
                marginBottom: "2px",
              }}
            >
              Year
            </label>
            <div className="events-archived-filter-controls">
              <DatePicker
                picker="year"
                value={
                  archivedYear ? dayjs(String(archivedYear), "YYYY") : null
                }
                onChange={(value) => {
                  if (!value) {
                    setArchivedYear("");
                  } else {
                    setArchivedYear(value.format("YYYY"));
                  }
                }}
                format="YYYY"
                allowClear={true}
                placeholder="YYYY"
                style={{
                  width: "90px",
                  border: "1px solid #D9D9D9",
                  borderRadius: "8px",
                  padding: "4px 6px",
                  height: "32px",
                  fontSize: "12px",
                }}
              />
              <button
                type="button"
                onClick={handleApplyArchivedYear}
                style={{
                  fontSize: "12px",
                  padding: "4px 8px",
                  borderRadius: "4px",
                  border: "1px solid #1890ff",
                  backgroundColor: "#1890ff",
                  color: "#fff",
                }}
              >
                Apply
              </button>
              <button
                type="button"
                onClick={handleClearArchivedYear}
                style={{
                  fontSize: "12px",
                  padding: "4px 8px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                  backgroundColor: "#fff",
                }}
              >
                Clear
              </button>
            </div>
          </div>
          </div>
          <div className="events-archived-filters-row events-archived-filters-row--selects">
            <div className="selctions-option position-relative">
              <label
                style={{
                  fontSize: "12px",
                  fontWeight: "600",
                  display: "block",
                  marginBottom: "2px",
                  paddingLeft: "4px",
                }}
              >
                Host Name
              </label>
              <div
                className="selection-drop text-nowrap event-selection-drop"
                style={{ fontWeight: "bold" }}
                onClick={() => {
                  setShowArchivedHostDropdown((prev) => !prev);
                  setShowArchivedTypeDropdown(false);
                  setShowArchivedLineColorDropdown(false);
                }}
              >
                {archivedHostFilter || "All"}
              </div>
              {showArchivedHostDropdown && (
                <div className="member-list" style={{ width: "100%" }}>
                  <div
                    className="member-item cursor-pointer"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setArchivedHostFilter("");
                      setShowArchivedHostDropdown(false);
                    }}
                  >
                    All
                  </div>
                  {archivedHostOptions.map((name) => (
                    <div
                      key={name}
                      className="member-item cursor-pointer"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setArchivedHostFilter(name);
                        setShowArchivedHostDropdown(false);
                      }}
                    >
                      {name}
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div className="selctions-option position-relative">
              <label
                style={{
                  fontSize: "12px",
                  fontWeight: "600",
                  display: "block",
                  marginBottom: "2px",
                  paddingLeft: "4px",
                }}
              >
                Type of Event
              </label>
              <div
                className="selection-drop text-nowrap event-selection-drop"
                style={{ fontWeight: "bold" }}
                onClick={() => {
                  setShowArchivedTypeDropdown((prev) => !prev);
                  setShowArchivedHostDropdown(false);
                  setShowArchivedLineColorDropdown(false);
                }}
              >
                {archivedTypeFilter || "All"}
              </div>
              {showArchivedTypeDropdown && (
                <div className="member-list" style={{ width: "100%" }}>
                  <div
                    className="member-item cursor-pointer"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setArchivedTypeFilter("");
                      setShowArchivedTypeDropdown(false);
                    }}
                  >
                    All
                  </div>
                  {archivedTypeOptions.map((type) => (
                    <div
                      key={type}
                      className="member-item cursor-pointer"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setArchivedTypeFilter(type);
                        setShowArchivedTypeDropdown(false);
                      }}
                    >
                      {type}
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div className="selctions-option position-relative">
              <label
                style={{
                  fontSize: "12px",
                  fontWeight: "600",
                  display: "block",
                  marginBottom: "2px",
                  paddingLeft: "4px",
                }}
              >
                Line Color
              </label>
              <div
                className="selection-drop text-nowrap event-selection-drop"
                style={{ fontWeight: "bold" }}
                onClick={() => {
                  setShowArchivedLineColorDropdown((prev) => !prev);
                  setShowArchivedHostDropdown(false);
                  setShowArchivedTypeDropdown(false);
                }}
              >
                {archivedLineColorFilter || "All"}
              </div>
              {showArchivedLineColorDropdown && (
                <div className="member-list" style={{ width: "100%" }}>
                  <div
                    className="member-item cursor-pointer"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setArchivedLineColorFilter("");
                      setShowArchivedLineColorDropdown(false);
                    }}
                  >
                    All
                  </div>
                  {archivedLineColorOptions.map((color) => (
                    <div
                      key={color}
                      className="member-item cursor-pointer"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setArchivedLineColorFilter(color);
                        setShowArchivedLineColorDropdown(false);
                      }}
                    >
                      {color}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
          <div className="events-archived-filters-row events-archived-filters-row--actions">
            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
                fontSize: "12px",
                fontWeight: "600",
              }}
            >
              <input
                type="checkbox"
                style={{ width: "22px", height: "22px" }}
                checked={
                  archivedInvitations.length > 0 &&
                  selectedArchivedIds.length > 0 &&
                  archivedInvitations
                    .map((evt) => evt.id)
                    .filter((id) => id != null)
                    .every((id) => selectedArchivedIds.includes(id))
                }
                onChange={toggleSelectAllArchived}
              />
              Select All
            </label>
            <button
              type="button"
              onClick={handleBulkDeleteArchived}
              disabled={selectedArchivedIds.length === 0}
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "4px 8px",
                borderRadius: "50%",
                backgroundColor:
                  selectedArchivedIds.length === 0 ? "" : "",
                color: "#fff",
                cursor:
                  selectedArchivedIds.length === 0 ? "not-allowed" : "pointer",
                width: "32px",
                height: "32px",
                border: "0",
              }}
            >
              <img
                src={window.getPublicUrl("/assets/images/deleteEvent.svg")}
                alt="Delete selected"
              />
            </button>
          <div className="events-archived-search">
            <div style={{ position: "relative" }}>
              <input
                type="text"
                className="events-search-input"
                placeholder="Search..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                style={{ width: "100%", marginLeft: "auto", minWidth: "auto", height: "32px", paddingRight: search ? "32px" : "14px" }}
              />
              {search && (
                <span
                  onClick={() => setSearch("")}
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    color: "#555",
                    fontSize: "16px",
                    lineHeight: 1,
                    fontWeight: "bold",
                    userSelect: "none",
                  }}
                >
                  ×
                </span>
              )}
            </div>
          </div>
          </div>
        </div>
      )}

      {/* ===== CONTENT ===== */}

      <div className="events-content">
        {activeTab === "myInvitations" ? (
          <MyInvitation
            search={search}
            openAddEditModal={openAddEditModal}
            openDeleteModal={openDeleteModal}
            events={myInvitations}
            loading={loading}
            cardVariant="my-invitations"
          />
        ) : activeTab === "draft" ? (
          <MyInvitation
            search={search}
            openAddEditModal={openAddEditModal}
            openDeleteModal={openDeleteModal}
            events={draftInvitations}
            loading={loading}
            cardVariant="my-invitations"
            isDraft={true}
          />
        ) : activeTab === "received" ? (
          <RecievedInvitation
            search={search}
            onCountChange={setRecievedInvitationCount}
            events={receivedInvitations}
            loading={loading}
            onRefresh={refreshEvents}
            onFilterChange={refreshEvents}
            receivedEventsCounts={receivedEventsCounts}
          />
        ) : (
          <MyInvitation
            search={search}
            openAddEditModal={openAddEditModal}
            openDeleteModal={openDeleteModal}
            events={filteredArchivedInvitations}
            loading={loading}
            isArchived={true}
            selectedIds={selectedArchivedIds}
            onToggleSelect={toggleSelectArchived}
            cardVariant="archived"
          />
        )}
      </div>

      {/* ===== POPUP ===== */}
      <Modal
        isOpen={showPopup}
        // onRequestClose={setShowPopup}
        onRequestClose={() => setShowPopup(false)}
        contentLabel="Notification Modal"
        overlayClassName="popup-overlay invite-overlay"
        portalClassName="event-moodal popup-card addmember-card create-event-modal"
        ariaHideApp={false}
      >
        <CreateEventModal
          isOpen={showPopup}
          eventDetails={eventDetail}
          editMode={editMode}
          onClose={handleModalClose}
          family_tree_id={familyTreeId}
        />
      </Modal>

      {/* ===== DELETE POPUP ===== */}
      <DeleteEventModal
        isOpen={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        eventId={selectedEvent?.id}
        onDeleted={refreshEvents}
        mode={deleteMode}
        isArchivedDelete={activeTab === "archived"}
      />

      {/* Bulk delete confirmation modal for archived invitations */}
      <Modal
        isOpen={showBulkDeleteModal}
        onRequestClose={() => setShowBulkDeleteModal(false)}
        style={{
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            border: "none",
            background: "transparent",
            padding: "0",
            maxWidth: "420px",
            width: "100%",
          },
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1000,
          },
        }}
        portalClassName="logOut"
        contentLabel="Delete Event Confirmation"
        ariaHideApp={false}
      >
        <div className="modal-content">
          <div className="modal-header">
            <div>
              <span>
                <img
                  src={window.getPublicUrl("/assets/images/logout.svg")}
                  alt=""
                />
              </span>
              <button
                type="button"
                className="close"
                onClick={() => setShowBulkDeleteModal(false)}
                aria-label="Close"
              >
                <img
                  src={window.getPublicUrl("/assets/images/close.svg")}
                  alt=""
                />
              </button>
            </div>
          </div>
          <div className="modal-body">
            <h5 className="modal-body-hading">Delete Event</h5>
            <p className="modal-peragrapgh">
              Are you sure you want to delete these events? Deleting the events
              will permanently remove this event.
            </p>
          </div>
          <div
            className="modal-footer"
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "12px",
            }}
          >
            <button
              type="button"
              className="btn btn-cancel"
              onClick={() => !bulkDeleting && setShowBulkDeleteModal(false)}
              disabled={bulkDeleting}
              style={{ width: "170px", height: "48px" }}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-block"
              onClick={performBulkDeleteArchived}
              disabled={bulkDeleting}
              style={{ width: "170px", height: "48px" }}
            >
              {bulkDeleting ? "Deleting..." : "Yes, Delete Event"}
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default Event;
